var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLocation = function SvgLocation(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-24": 17,
    viewBox: "0 0 11.1 14.7",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.523 6.754a1.538 1.538 0 1 0 0-3.077 1.538 1.538 0 0 0 0 3.077"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M5.523.6a4.615 4.615 0 0 1 4.616 4.615c0 3.73-4.616 6.462-4.616 6.462S.908 8.945.908 5.215A4.615 4.615 0 0 1 5.523.6M10.446 12.293v.615a1.23 1.23 0 0 1-1.23 1.23H1.83a1.23 1.23 0 0 1-1.23-1.23v-.615"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLocation);
export default ForwardRef;